export default {
  parkUrl: process.env.parkUrl,
  corpUrl: process.env.corpUrl,
  apiUrl: process.env.apiUrl,
  pcUrl: process.env.pcUrl,

  wxLoginUrl: process.env.wxLoginUrl,
};


// WEBPACK FOOTER //
// ./src/static/backstageUrl.js